export const UNSUPPORTED_ENVIRONMENT = typeof window === "undefined";
